export default 
{
  type: "form-date",
  style: "",
  data: {
    label: "New Date Field",
    placeholder: "2023-02-27",
    format: "YYYY-MM-DD",
  },
  children: [],
};
